/* file description */
import { message } from 'antd';
import { TIP_MSG_MAP } from '../model-apis/consts';
import { getAssetModuleRecord } from './assetModel';

interface GetRecordModuleByRequestProps {
  FetchAPI?: any;
  namespaceID: string;
  moduleID: string;
  recordID: string;
}
export const getRecordModuleByRequest = async ({
  FetchAPI,
  namespaceID,
  moduleID,
  recordID,
}: GetRecordModuleByRequestProps) => {
  try {
    const res = await getAssetModuleRecord(FetchAPI, namespaceID, moduleID, recordID);
    return res;
  } catch {
    message.error(TIP_MSG_MAP.getRecordError);
    return {};
  }
};
